import React, { useState, useEffect } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { useLang } from '../../util/lang';

const WarningDialog = ({ title, children, open, setOpen, onConfirm }) => {
    const get = useLang();

    return (
        <Dialog open={open} onClose={() => setOpen(false)} aria-labelledby="confirm-dialog">
            <DialogTitle id="confirm-dialog">{title}</DialogTitle>
            <DialogContent>{children}</DialogContent>
            <DialogActions>
                <Button
                    variant="contained"
                    onClick={() => {
                        setOpen(false);
                        if (onConfirm) onConfirm();
                    }}
                    style={{ backgroundColor: '#0080FF', color: 'white' }}
                >
                    {get(':const.confirm')}
                </Button>
                <Button
                    // variant="contained"
                    onClick={() => setOpen(false)}
                >
                    {get(':const.cancel')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};
export default WarningDialog;
